import {calendarDate,toCents,fromCents} from './financialMath.js';
import {accountingEntries,monthlyBudgetCents} from './financialLedger.js';
const monthBounds=value=>{
 const iso=calendarDate(value);
 const [year,month]=iso.slice(0,7).split('-').map(Number);
 return {start:iso.slice(0,7)+'-01',end:new Date(Date.UTC(year,month,0)).toISOString().slice(0,10),
   days:new Date(Date.UTC(year,month,0)).getUTCDate()};
};
// This is a pace estimate, not a statement of cash in the bank.
// Scheduled accruals are counted exactly once and displayed separately.
export function buildBudgetInsights({budgets=[],transactions=[],ious=[],asOf=new Date(),monthDate=asOf,fiscalYearStart='07-01',warningPercent=80}){
 const bounds=monthBounds(monthDate),today=calendarDate(asOf);
 const currentMonth=today.slice(0,7)===bounds.start.slice(0,7);
 const ended=bounds.end<today,upcoming=bounds.start>today;
 const elapsed=ended?bounds.days:upcoming?0:Math.min(bounds.days,Number(today.slice(8,10)));
 const entries=accountingEntries(transactions,'accrual',ious);
 return budgets.filter(b=>b && !b.isDeleted && b.type!=='income').map(b=>{
  const limit=monthlyBudgetCents(b,monthDate,fiscalYearStart);
  const inPeriod=entries.filter(t=>t.type==='expense'&&t.category===b.category&&
    calendarDate(t.date)>=bounds.start&&calendarDate(t.date)<=bounds.end&&
    (b.period!=='custom'||(calendarDate(t.date)>=calendarDate(b.startDate)&&calendarDate(t.date)<=calendarDate(b.endDate))));
  const spentCents=inPeriod.filter(t=>calendarDate(t.date)<=today &&
    (t.isDailyBreakdown||t.status==='posted')).reduce((n,t)=>n+toCents(t.amount),0);
  const scheduledCents=inPeriod.filter(t=>calendarDate(t.date)>today).reduce((n,t)=>n+toCents(t.amount),0);
  const paceCents=elapsed>0 ? Math.round(spentCents*bounds.days/elapsed) : 0;
  const projectedCents=ended?spentCents:upcoming?scheduledCents:
    Math.max(spentCents+scheduledCents,paceCents);
  const ratio=limit>0?spentCents/limit:0,projectedRatio=limit>0?projectedCents/limit:0;
  const status=limit<=0?'no-limit':spentCents>limit?'over':
    projectedCents>limit?'forecast-over':ratio>=warningPercent/100?'warning':'on-track';
  return {...b,month:bounds.start.slice(0,7),spent:fromCents(spentCents),
    scheduled:fromCents(scheduledCents),limit:fromCents(limit),
    projected:fromCents(projectedCents),remaining:fromCents(limit-spentCents),
    projectedRemaining:fromCents(limit-projectedCents),ratio,projectedRatio,status,
    isEstimate:!ended,elapsedDays:elapsed,totalDays:bounds.days};
 });
}